import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

export default function CirculatingSupply() {
  return 6000000;
}
